var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mt-3",
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              staticClass: "btnFilter_2 mr-2",
              attrs: { variant: "primary" },
              on: { click: _vm.newMandate },
            },
            [
              _c("i", { staticClass: "fa-light fa-plus" }),
              _vm._v(" "),
              _c("span", { staticClass: "fab-label" }, [
                _vm._v(_vm._s(_vm.$t("mandate.new_mandate"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "btnFilter_2 mr-2 w-100",
              on: { click: _vm.exportMandateBulk },
            },
            [
              _c("i", { staticClass: "fa-light fa-upload" }),
              _vm._v(
                "\n        " + _vm._s(_vm.$t("mandate.export")) + "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "btnFilter_2 mr-2 w-100",
              on: {
                click: function ($event) {
                  _vm.displayFilter = !_vm.displayFilter
                },
              },
            },
            [
              _vm.displayFilter
                ? _c("i", { staticClass: "fa-light fa-minus" })
                : _c("i", { staticClass: "fa-light fa-plus" }),
              _vm._v("\n        " + _vm._s(_vm.$t("filter.fltr")) + "\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            { staticClass: "btnFilter_2 w-100", on: { click: _vm.onRefresh } },
            [
              _c("i", { staticClass: "fa-light fa-rotate-right" }),
              _vm._v(
                "\n        " + _vm._s(_vm.$t("common.rfrsh")) + "\n      "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mx-auto" }),
      _vm._v(" "),
      _vm.displayFilter
        ? _c(
            "b-row",
            {
              staticClass: "min-w-100 justify-content-start align-items-center",
            },
            [
              _c("b-col", { attrs: { cols: "3" } }, [
                _c("span", { staticClass: "filter-item-title d-block mb-1" }, [
                  _vm._v(_vm._s(_vm.$t("mandate.file_name"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.FileName,
                      expression: "FileName",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "filter-item-content w-100",
                  staticStyle: { padding: "0.13rem" },
                  attrs: { placeholder: _vm.$t("mandate.file_name") },
                  domProps: { value: _vm.FileName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.FileName = $event.target.value.trim()
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "3" } }, [
                _c(
                  "div",
                  [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("Webheader.date_begin")))]
                    ),
                    _vm._v(" "),
                    _c("datetime-picker-custom", {
                      staticClass: "mr-3",
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.dateBeginFilter,
                      },
                      staticStyle: { padding: "0.35rem" },
                      attrs: {
                        format: "YYYY-MM-DD HH:mm:ss",
                        periodFull: "",
                        id: "filter-datebegin",
                        customInputParentClass: "filter-item-content",
                        customInputClass: "w-100",
                        maxLength: 19,
                        placeholderValue: _vm.$t(
                          "common.datepicker_format_date2"
                        ),
                        inputIcon: "fa-solid fa-calendar",
                      },
                      model: {
                        value: _vm.dateBeginFilter,
                        callback: function ($$v) {
                          _vm.dateBeginFilter = $$v
                        },
                        expression: "dateBeginFilter",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "3" } }, [
                _c(
                  "div",
                  [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("Webheader.date_end")))]
                    ),
                    _vm._v(" "),
                    _c("datetime-picker-custom", {
                      staticClass: "mr-3",
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.dateEndFilter,
                      },
                      staticStyle: { padding: "0.35rem" },
                      attrs: {
                        format: "YYYY-MM-DD HH:mm:ss",
                        periodFull: "",
                        id: "filter-dateend",
                        customInputParentClass: "filter-item-content",
                        customInputClass: "w-100",
                        maxLength: 19,
                        placeholderValue: _vm.$t(
                          "common.datepicker_format_date2"
                        ),
                        inputIcon: "fa-solid fa-calendar",
                      },
                      model: {
                        value: _vm.dateEndFilter,
                        callback: function ($$v) {
                          _vm.dateEndFilter = $$v
                        },
                        expression: "dateEndFilter",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass:
                    "min-w-100 justify-content-end align-items-center",
                },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mt-3",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter_2 mr-2 w-100",
                          attrs: { disabled: !_vm.hasInputFilter },
                          on: { click: _vm.clearFilterFields },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.rst")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter_2 w-100",
                          on: { click: _vm.onRefresh },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.srch")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayFilter ? _c("hr", { staticClass: "mx-auto mb-4" }) : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "mx-auto mb-4", attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticStyle: { overflow: "auto" } },
              [
                _vm.activateSpinner
                  ? _c("spinner")
                  : _vm.listItemsMandateBulk.length > 0
                  ? _c("b-table", {
                      key: _vm.refreshKey,
                      staticClass: "table table-striped",
                      staticStyle: { "margin-bottom": "0" },
                      attrs: {
                        hover: "",
                        striped: "",
                        responsive: "",
                        items: _vm.listItemsMandateBulk,
                        fields: _vm.fields,
                        "sort-by": _vm.sortBy,
                        "sort-desc": _vm.sortDir,
                        "empty-text": _vm.$t("common.security.no_result"),
                      },
                      on: {
                        "update:sortBy": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sort-by": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sortDesc": function ($event) {
                          _vm.sortDir = $event
                        },
                        "update:sort-desc": function ($event) {
                          _vm.sortDir = $event
                        },
                        "head-clicked": _vm.sortTable,
                        "row-clicked": _vm.onRowClicked,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "cell(FileName)",
                          fn: function (data) {
                            return [
                              data.value !== ""
                                ? _c("span", [_vm._v(" " + _vm._s(data.value))])
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                        {
                          key: "cell(CreationDate)",
                          fn: function (data) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.formatDate(data.value)) +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(NbLinesTotal)",
                          fn: function (data) {
                            return [
                              data.value !== ""
                                ? _c("span", [_vm._v(" " + _vm._s(data.value))])
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                        {
                          key: "cell(NbLinesTreated)",
                          fn: function (data) {
                            return [
                              data.value !== ""
                                ? _c("span", [_vm._v(" " + _vm._s(data.value))])
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                        {
                          key: "cell(actions)",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "b-link",
                                {
                                  staticClass: "text-decoration-none",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.onRowClicked(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("mandate.view_details")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    })
                  : _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c("span", { staticClass: "noResult" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.no_result")) +
                              "\n          "
                          ),
                        ]),
                      ]
                    ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            [
              _c("cm-pagination", {
                attrs: {
                  maxResultsByPage: _vm.paginationObject.maxResults,
                  firstIndex: _vm.paginationObject.firstIndex,
                  nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                  refreshEvent: _vm.paginationObject.refresh,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }